<template>
	<div>
		<OverrideRotation/>
	</div>
</template>

<style>
</style>

<script>
import * as BABYLON from 'babylonjs';
import Constructor from './Constructor';
import {mapGetters, mapState,mapMutations} from 'vuex'
import MediaManager from "@/api/MediaManager";
import MaterialManager from "@/components/babylonjs/Materials";
import {Media} from '@/store/flux360/MediaManagerDataTypes';
import {Request} from '@/store/flux360/Request';
import {NotifyPositionEvent} from '@/store/flux360/EventDataTypes';
import OverrideRotation from "@/components/babylonjs/OverrideRotation.vue";

export default {
	components: {OverrideRotation},
	inject: ["getEngine", "getCanvas",'changeSession'],
	props: {
		debug: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data: () => ({
		scene: null,
		situationsNode: undefined, // All situations are gathered below this node
		usersNode: undefined, // All users are gathered below this node
		eventsNode: undefined, // All events are gathered below this node
		assetsManager: null,
		localUserPosition: new BABYLON.Vector3.Zero(),
        localUserRotation: new BABYLON.Vector4.Zero(),
        lastUserUpdateTimeStamp: 0.0,
        userUpdateDeltaMS: 1000 / 10, // Defines the milliseconds between user updates
		components: [],
		vrHelper: undefined,
		tapedTwice: false,
		publicPath: process.env.BASE_URL,
		gyrosCamera: null,
		mainCamera: null,
	}),
	computed: {
		...mapState(['vrMode']),
		...mapGetters(['situations','currentPrefabs', 'currentSituation', 'currentSituationID', 'panoramaTour', 'prefabsForSituation', 'remoteUsersInCurrentSituation','doRendering','secondaryColor','primaryColor',
						'localUser', 'events','commands','isVRMode', 'users',"isGyrosActive","enableInternWebsiteViewer","enableCommunication","enableZooming","enablePanoramaVideoAutoplay",'fontFamily']),
		...mapState({isOnboardingComplete: (state) => state.session.isOnboardingComplete}),
		engine: function () {
			return this.getEngine();
		},
		currentComponents: function () {
			return this.components.filter(x => x.getSituationID() === this.currentSituationID);
		},
		currentEvents: function() {
			return this.events.filter( x => x.getSituationID() === this.currentSituationID );
		},
		currentCommands: function() {
			return this.commands;
		},
		currentSituationComponent(){
			let c  = this.components.filter( x => x.getID() === this.currentSituationID );
			if(c && c.length > 0)
				return c[0];
			else
				return undefined; 
		},
		isVRModeEnbaled: function() {
			return this.isVRMode;
		},
		currentSituationRuntimeStateRequests: function(){
			return this.currentSituation ? this.currentSituation.runtimeState.requests: undefined;
		}
	},
	provide() {
		return {
			getScene: this.getScene
		}
	},
	methods: {
		 ...mapMutations(["updateUser",'updateRuntimeState','setLoadingscreenVisible','setScene']),
		getScene(){
			return this.scene;
		},
		initialize () {
			this.initializeScene();
			this.initializeAssetsManager();
			this.initializeCamera();
			this.initializeLighting();
			this.initializeSceneGraph();
			this.initializeActionManager();
			MaterialManager.initialize( this.scene );
		},
		initializeScene() {
			this.scene = new BABYLON.Scene(this.getEngine());
			this.setScene(this.scene);
			this.scene.useRightHandedSystem = false;
			this.scene.clearColor = BABYLON.Color3.White();
			if( this.debug )
				this.scene.debugLayer.show();
			let panoramaScene = this;
			this.scene.onBeforeCameraRenderObservable.add( function( camera ) {
                let timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
                if( timeStampInMs - panoramaScene.lastUserUpdateTimeStamp > panoramaScene.userUpdateDeltaMS || panoramaScene.lastUserUpdateTimeStamp === 0 )
                {
				    //console.log("Before rendering camera " + camera.name );
				    let position = camera.position;
				    let rotation = camera.absoluteRotation.toEulerAngles();
				    let update = {
    					id: panoramaScene.$store.state.flux360.localUserID,
					    currentSituationID: panoramaScene.$store.getters.currentSituationID
				    };
				    if( !position.equalsWithEpsilon( panoramaScene.localUserPosition, 0.001 )) {
    					panoramaScene.localUserPosition = { ...position };
					    update.position = { ...position };
                        update.position.x = Math.round(update.position.x * 100)/100;//update.position.x.toFixed(3);
                        update.position.y = Math.round(update.position.y * 100)/100;//update.position.x.toFixed(3);
                        update.position.z = Math.round(update.position.z * 100)/100;//update.position.x.toFixed(3);
				    }
				    if( !rotation.equalsWithEpsilon( panoramaScene.localUserRotation, 0.001 )) {
    					panoramaScene.localUserRotation = { ...rotation };
					    update.rotation = { ...rotation };
                        update.rotation.x = Math.round(update.rotation.x * 100)/100;//update.position.x.toFixed(3);
                        update.rotation.y = Math.round(update.rotation.y * 100)/100;//update.position.x.toFixed(3);
                        update.rotation.z = Math.round(update.rotation.z * 100)/100;//update.position.x.toFixed(3);
					    //console.log("Camera rotation changed: " + JSON.stringify(rotation));
				    }
				    if( Object.keys(update).length > 2 ) {
						//console.log("committing user " + JSON.stringify(update));
					    panoramaScene.$store.commit('updateUser', update);
                        //Promise.resolve(panoramaScene.$store.dispatch('broadcastUserUpdate', update));
                        panoramaScene.lastUserUpdateTimeStamp = timeStampInMs;
					}
						
                }
			})
			// this.scene.onPointerMove = function( e, pi ) {
			// 	if( pi.hit ) {
			// 		//console.log("Hit " + pi.pickedMesh.name);
			// 		//console.log("Point: " + JSON.stringify(pi.pickedPoint));
			// 	} else {
			// 		//console.log("Direction " + JSON.stringify(pi.ray.direction) )
			// 		//console.log("Length " + JSON.stringify(pi.ray.length) )
			// 	}
			// 	//console.log("PP: " + JSON.stringify(e));
			// 	//console.log("PI: " + JSON.stringify(pi));
			// 	//console.log("TI: " + JSON.stringify(typeInfo));
			// }

			document.getElementById("renderCanvas").addEventListener("dblclick", function () {
				panoramaScene.onDblClick();
			});

			document.getElementById("renderCanvas").addEventListener("wheel", function (e) {
				panoramaScene.onZoom(e);
			});

			// document.getElementById("renderCanvas").addEventListener('gestureend', function(e) {
			// 	panoramaScene.onZoom(e);
			// });
			
			//dblclick for mobile
			// document.getElementById("renderCanvas").addEventListener("touchstart", function (e) {
			// 	if(!panoramaScene.tapedTwice) {
			// 		panoramaScene.tapedTwice = true;
			// 		setTimeout( function() { panoramaScene.tapedTwice = false; }, 300 );
			// 	}else{
			// 		panoramaScene.onDblClick();
			// 	}		
			// });
		},
		initializeAssetsManager () {
			this.assetsManager = new BABYLON.AssetsManager(this.scene);
			this.assetsManager.onTaskErrorObservable.add(function (task) {
				console.log('Flux360BabylonEngine:: Task failed', task.errorObject.message, task.errorObject.exception);
			});
			this.assetsManager.onProgress = (remainingCount, totalCount) => {
				this.getEngine().loadingScreen.setLoadingUIText((100 * (totalCount - remainingCount) / totalCount).toFixed(0) + "%");
				//console.log( 'We are loading the scene. ' + remainingCount + ' out of ' + totalCount + ' items still need to be loaded.' );
			};
		},
		initializeCamera () {
			this.mainCamera = new BABYLON.ArcRotateCamera("MainCamera",Math.PI / 2,Math.PI / 2,2,BABYLON.Vector3.Zero(),this.scene); 
			this.mainCamera.attachControl(this.getCanvas(), true, false,4);
			this.mainCamera.inputs.attached.mousewheel.detachControl(this.getCanvas());
			this.mainCamera.invertRotation = true;
			this.mainCamera.lowerRadiusLimit = 1; // Stop zooming in
			this.mainCamera.upperRadiusLimit = 1; // Stop zooming out
			this.mainCamera.angularSensibilityX = 3000;
			this.mainCamera.angularSensibilityY = 3000;
			this.mainCamera.fov = 0.85;
			
			this.gyrosCamera = new BABYLON.DeviceOrientationCamera("GyrosCamera",BABYLON.Vector3.Zero(),this.scene); 
			this.gyrosCamera.attachControl(this.getCanvas(), true);
		},
		initializeLighting () {
			new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(1, 1, 0), this.scene);
		},
		initializeSceneGraph () {
			// Check if we already have a situations node
			if (!this.situationsNode)
				this.situationsNode = new BABYLON.TransformNode("Situations", this.scene);
			if (!this.usersNode)
				this.usersNode = new BABYLON.TransformNode("Users", this.scene);
			if (!this.eventsNode)
				this.eventsNode = new BABYLON.TransformNode("Events", this.scene);
			Promise.resolve(this.$store.dispatch('broadcastUserUpdate', this.user));
		},
		initializeActionManager() {
			let panoramaScene = this;

			this.scene.actionManager = new BABYLON.ActionManager(this.scene);

			// this.scene.actionManager.registerAction(
			// 	new BABYLON.ExecuteCodeAction({
			// 			trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 			parameter: 'u' //press "s" key
			// 	},
			// 	function () { 
			// 		panoramaScene.$store.dispatch('addTestUser');
			// 	}
			// ));

			/// Register the function to call all users to the current user.
			this.scene.actionManager.registerAction(
				new BABYLON.ExecuteCodeAction({
						trigger: BABYLON.ActionManager.OnKeyDownTrigger,
						parameter: 'c' //press "c" key
				},
				function () { 
					let camera =  panoramaScene.scene.getCameraByName("MainCamera");
					let data = {
						targetRotation: { x: camera.beta, y: camera.alpha, z: 0 }
					}
					panoramaScene.$store.dispatch('requestUsersToMe', data);
				}
			));
	  
			// // From 2D view to fullscreen VR
			// this.scene.actionManager.registerAction(
			// 		new BABYLON.ExecuteCodeAction({
			// 				trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 				parameter: 'v' //press "s" key
			// 		},
			// 		function () { vrHelper.enterVR(); }
			// ));
			// // From fullscreenVR to 2D view
			// this.scene.actionManager.registerAction(
			// 		new BABYLON.ExecuteCodeAction({
			// 				trigger: BABYLON.ActionManager.OnKeyDownTrigger,
			// 				parameter: 'e' //press "e" key
			// 		},
			// 		function () { vrHelper.exitVR(); document.exitFullscreen();}
			// ));
		},
		render () {
			if (this.scene && this.doRendering) {
				// Call the update function on all components...
				this.components.filter(x => x.getSituationID() === this.currentSituationID)
						.forEach(x => {
							x.update(this)
						});
				MaterialManager.update();
				this.scene.render();
			}
		},
		startRenderLoop () {
			this.getEngine().runRenderLoop(() => this.render());
		},

		enterSituation (newSituation){
			if (!newSituation)
				return;
			
			let cameraMain =  this.scene.getCameraByName("MainCamera");
			let userRotation = this.localUser.getRotation();
            if (!(userRotation === "undefined" || userRotation === undefined)){
				//console.log("Enter Situation - rotation is set !!" + JSON.stringify(userRotation));
				if( !isNaN(userRotation.y) && !isNaN(userRotation.x)){
					cameraMain.alpha = userRotation.y - 90*Math.PI / 180;
					cameraMain.beta = userRotation.x + 90*Math.PI / 180;
				}
                //console.log(JSON.stringify(cameraMain.rotation));
			}
			
			console.log(`... going to enter ${JSON.stringify(newSituation.name)}`);
			if (!this.coversSituation(newSituation)) {
				this.preloadSituation(newSituation).then(() => {
					console.log("Now, creating Situation");
					this.createSituation(newSituation);
				});
			} else {
				console.log("... reactivating Situation");
				const situationNode = this.situationsNode;
				if (situationNode) {
					situationNode.getChildren().forEach(child => {
						if (child.name === this.getSituationNodeName(newSituation.getID())) {
							console.log("... enabling situation..." + child.name + " " + child.id + child.getChildren().length);
							child.setEnabled(true);
						}
					})
				}
				const componentsToCheck = this.components.filter(x => x.getSituationID() === newSituation.getSituationID());
				componentsToCheck.forEach(component => {component.enable()});
			}
		},
		leaveSituation (oldSituation) {
			if (!oldSituation)
				return;
			console.log(`... leaving situation ${oldSituation ? JSON.stringify(oldSituation.name) : "none"}`);
			const situationNode = this.situationsNode;
			if (situationNode) {
				situationNode.getChildren().forEach(child => {
					if (child.name === this.getSituationNodeName(oldSituation.getID())) {
						console.log("... disabling situation...");
						child.setEnabled(false);
					}
				})
			}

			let componentsToCheck = this.components.filter(x => x.getSituationID() === oldSituation.getSituationID());
			componentsToCheck.forEach(component => {
				component.disable();
			})
		
		/*
			if(this.$browserDetect.isSafari){
			if (situationNode) {
				situationNode.getChildren().forEach(child => {
					if (child.name === this.getSituationNodeName(oldSituation.getID())) {
						console.log("... removing situation...");

					}
				})
			}
			let componentsToCheck = this.components.filter(x => x.getSituationID() === oldSituation.getSituationID());
			componentsToCheck.forEach(component => {
				if (component) {
					var index = componentsToCheck.indexOf(component);
      				if (index > -1) {
        				componentsToCheck.splice(index, 1);
      				}  
   				
				}
			})
				
			}
			*/
		},

		preloadSituation (situation) {
			console.log("... preloading situation " + situation.getName());
			let contentIDs = situation.getContentIDs();
			contentIDs.push(285428);
			
			this.prefabsForSituation(situation.getID()).map(x => {
				if (x.getContentIDs()) {
					contentIDs = contentIDs.concat(x.getContentIDs());
				}
			})
			//var contentIDs = [].concat.apply([], contentIDsArrays);
			//console.log("Preloading contents " + contentIDs.length );

			const assetM = this.assetsManager;
			return new Promise(
				function (resolve, reject) {
					MediaManager.media.forEach(texture => {
						if (texture.getType() === Media.MediaType.Texture && !texture.getTexture() && contentIDs.includes(texture.id)) {
							const task = assetM.addTextureTask(texture.id, texture.getURL(),false,false);
							task.onSuccess = task => {
								texture.setTexture(task.texture);
								if (!texture.getWidth() || !texture.getHeight())
									texture.setSize(task.texture.getSize().width / 20,task.texture.getSize().height / 20);
							};
						}
					})
					assetM.onFinish = () => {
						console.log("... assets loaded.");
						resolve();
					}
					assetM.onTaskError = (error) => {
						console.error("... Loading assets failed!");
						reject(error);
					}
					console.log("... start preloading!")
					assetM.load();
				}
			);
		},
		createSituation (situation) {
			//console.log("... creating scenegraph for " + situation.getName());

			let situationNode = this.scene.getNodeByName(this.getSituationNodeName(situation.getID()));
			if (situationNode) {
				// maybe we can drop out here, as the situation is already there...
				return;
			} else {
				situationNode = new BABYLON.TransformNode(this.getSituationNodeName(situation.getID()), this.scene);
				var situationsNode = this.situationsNode;
				situationNode.parent = situationsNode;
			}
			// Construct Panorama
			let prefabComponent = Constructor.constructPrefabSubgraph(this, situation);
			this.components.push(prefabComponent);
			prefabComponent.getRootNode().parent = situationNode;

			// Construct all contents
			this.prefabsForSituation(situation.getID()).map(x => {
				//console.log("constructPrefabSubgraph: type: " + x.getType());
				let prefabComponent = Constructor.constructPrefabSubgraph(this, x);
				this.components.push(prefabComponent);
				prefabComponent.getRootNode().parent = situationNode;
			})
			//this.assetsManager.load();
		},
		coversSituation (situation) {
			//console.log("Test if we have this situation " + situation.getName() );
			if (this.scene.getNodeByName(this.getSituationNodeName(situation.getID())))
				return true;
			else
				return false;
		},
		getSituationNodeName (situation) {
			let name = situation;
			if (!Number.isInteger(situation))
				name = situation.getID();
			return "Situation_" + name;
		},
		onDblClick() {
			if(this.enableCommunication){
				// We try to pick an object
				var pickResult = this.scene.pick(this.scene.pointerX, this.scene.pointerY);
				if( pickResult.hit ) {
					//console.log("Picked at " + pickResult.distance);
					//console.log("          " + JSON.stringify(pickResult.pickedPoint));
					//if( pickResult.pickedMesh ) console.log("          " + pickResult.pickedMesh.name);

					let pos = pickResult.pickedPoint;
					pos.x = Math.round(pos.x * 100)/100;
					pos.y = Math.round(pos.y * 100)/100;
					pos.z = Math.round(pos.z * 100)/100;

					let event = new NotifyPositionEvent( 
						{ 
							userID: this.$store.state.flux360.localUserID,
							situationID: this.$store.getters.currentSituationID,
							position: pos,
							duration: 3000,
							rotation: this.scene.rotation,
							color: this.localUser.getColor()
						} );
					this.$store.commit( 'postEvent', event );
					/*
					var sphere = BABYLON.MeshBuilder.CreateSphere("sphere", {diameter: 10, diameterX: 10}, this.scene);
					sphere.position = pickResult.pickedPoint;
					sphere.rotate(BABYLON.Axis.X, - Math.PI / 2, BABYLON.Space.LOCAL );
					sphere.material = MaterialManager.get("info");
					*/
				}
				let audio = new Audio(require('@/assets/sounds/ripple.mp3'));
				audio.type = "audio/mpeg";
				audio.play();
			}
			if(this.isOnboardingComplete) {
				let audio = new Audio(require('@/assets/sounds/ripple.mp3'));
				audio.type = "audio/mpeg";
				audio.play();
			}
		},
		onZoom(e) {
			if(this.enableZooming){
				let scale = e.deltaY ? e.deltaY: e.scale;
				let fov = this.mainCamera.fov;
				if(fov < 1.350 && 0 < scale )
					this.mainCamera.fov += scale * 0.0005;
				if(0.5 < fov && scale < 0)
					this.mainCamera.fov += scale * 0.0005;	
			}
		}
	},
	watch: {
		currentSituationRuntimeStateRequests(){	
			this.currentComponents.forEach(x => {	
				if(x.getType() == "VideoSphere")
					this.currentSituationRuntimeStateRequests.forEach(r => {
						if (r.requestType === Request.RequestType.Pause) 
							x.pause();
						
						if (r.requestType === Request.RequestType.Play) 
							x.play();
						
						if (r.requestType === Request.RequestType.Reset) 
							x.reset();
						
						if (r.requestType === Request.RequestType.JumpToTimePosition) 
							x.jumpToTimePosition(r.timeToJumpTo);
						
						if (r.requestType === Request.RequestType.ChangeVolume) 
							x.changeVolume(r.volume);
					})
				this.currentSituationRuntimeStateRequests.length = 0;
			});
		},
		engine: function (newEngine, oldEngine) {
			console.log("Switched Engine from " + oldEngine + " to " + newEngine);
			this.initialize();
			this.startRenderLoop();
		},
		currentSituation: function (newValue, oldValue) {
			// Check if the value actually changed...
			if (oldValue && newValue && newValue.getID() === oldValue.getID())
				return;
			console.log(`Entered a new situation ${JSON.stringify(newValue.name)} <= ${oldValue ? JSON.stringify(oldValue.name) : "none"}`);
			if (oldValue === undefined || newValue.id !== oldValue.id) {
				if (oldValue !== -1) // only leave existing situations
					this.leaveSituation(oldValue);
				this.enterSituation(newValue);
			}
		},
		localUser: function (newValue, oldValue) {
			if (oldValue && newValue && oldValue.getID() === newValue.getID())
				return;
			console.log("Local user changed to " + newValue.getID());
		},
		remoteUsersInCurrentSituation: function (newValue, oldValue) {
			console.info(`PanoramaScene::remoteUsersInCurrentSituation old: ${JSON.stringify(oldValue)} new: ${JSON.stringify(
					newValue)}`);
			// Modify the scenegraph accordingly...
			let usersNode = this.scene.getNodeByName("Users");
			// Loop over users in current situation
			if (usersNode) {
				// Add all users missing in the current situation
				let userIDs = newValue.map(x => x.getID());
				usersNode.getDescendants(true, n => !userIDs.includes(n.name))
						.forEach(x => {
							x.setEnabled(false)
							// Search for matching component...
							let component = this.components.filter( y => y.getID() === x.name );
							console.log("Found " + component.length + " components to be removed");
							if( component ) {
								component.forEach( x => {
									console.log("Removing " + x.getID() );
									x.destruct();
									this.components.splice( this.components.indexOf( x ), 1 );
								});
							}				 			
						}); 
				usersNode.getDescendants(true, n => userIDs.includes(n.name))
						.forEach(x => {
							x.setEnabled(true);
							// Remove the user from the list
							userIDs = userIDs.filter(y => y !== x.name);
						});
				const usersToAdd = newValue.filter(x => userIDs.includes(x.getID()));
				if (usersToAdd)
					usersToAdd.forEach(newUser => {
						let userComponent = Constructor.constructPrefabSubgraph(this, newUser);
						this.components.push(userComponent);
						userComponent.getRootNode().parent = usersNode;
					})
			} 
		},  
		currentEvents: function (newValue, oldValue) {
			//console.info(`PanoramaScene::EventsChanged old: ${JSON.stringify(oldValue)} new: ${JSON.stringify(newValue)}`);
			// Now create the corresponding components...
			if( !this.scene )
				return;
			// Modify the scenegraph accordingly...
			let eventsNode = this.scene.getNodeByName("Events");
			// Loop over users in current situation
			if (eventsNode) {
				// Add all users missing in the current situation
				let eventIDs = newValue.map(x => x.getID());

				eventsNode.getDescendants(true, n => !eventIDs.includes(n.name))
						.forEach(x => {
							x.setEnabled(false);
							// Search for matching component...
							let component = this.components.filter( y => y.getID() === x.name );
							console.log("Found " + component.length + " components to be removed");
							if( component ) {
								component.forEach( x => {
									console.log("Removing " + x.getID() );
									x.destruct();
									this.components.splice( this.components.indexOf( x ), 1 );
								});
							}
						});
				eventsNode.getDescendants(true, n => eventIDs.includes(n.name))
						.forEach(x => {
							x.setEnabled(true);
							// Remove the user from the list
							eventIDs = eventIDs.filter(y => y !== x.name);
						});
				const eventsToAdd = newValue.filter(x => eventIDs.includes(x.getID()));
				if (eventsToAdd)
					eventsToAdd.forEach(newEvent => {
						//console.log("Adding event " + JSON.stringify(newEvent));
						let eventComponent = Constructor.constructPrefabSubgraph(this, newEvent);
						this.components.push(eventComponent);
						eventComponent.getRootNode().parent = eventsNode;
					})
			}
		},
		currentCommands: function (newValue, oldValue) {
			if( newValue ) {
				newValue.filter( x => !x.isCompleted() ).forEach( x => 
				{
					if( x.getType() === "ComeTo" ) {
						this.$store.commit( 'handleGotoSituationTransition',  
                		{               
                    		situationID: x.getSituationID(), 
                    		rotation: x.getRotation()
						}); 
						
						setTimeout( () => {
							let cameraMain =  this.scene.getCameraByName("MainCamera");
							if( cameraMain ) {
			                	cameraMain.alpha = x.getRotation().y; // - 90*Math.PI / 180;
                				cameraMain.beta = x.getRotation().x; // + 90*Math.PI / 180;
							}
						}, 200);
						x.setCompleted();
					}
				})
			}
		},
		isVRMode: function (newValue, oldValue) {
			console.log("isVRMode changed")			;
			if( newValue )
			{ 
				if( !this.vrHelper )
					this.vrHelper = this.scene.createDefaultVRExperience();
				this.vrHelper.enterVR(); }
			else
			{ this.vrHelper.exitVR(); document.exitFullscreen();}
		},
		debug: function (val) {
			if (this.scene && val)
				this.scene.debugLayer.show();
			else
				this.scene.debugLayer.hide();
		},
		isGyrosActive: function(){
			if(this.isGyrosActive){
				if (typeof DeviceOrientationEvent.requestPermission === 'function') 
					DeviceOrientationEvent.requestPermission().then(permissionState => {
						if (permissionState === 'granted') 
							window.addEventListener('deviceorientation', () => {});
						
					}).catch(console.error);
				this.scene.activeCamera = this.gyrosCamera;
			}else{
				this.scene.activeCamera = this.mainCamera;
			}
		},
	},
}
</script>
